import {Space} from "antd";
import {CustomerServiceOrderWorkDeliveryDeliveredWork} from "./delivered-work";
import {CustomerServiceOrderWorkDeliveryHeader} from "./header";
import {CustomerServiceOrderDrawerOrderInfoProps} from "../order-info";

export type CustomerServiceOrderWorkDeliveryProps = {
  status: CustomerServiceOrderDrawerOrderInfoProps["status"];
  productServiceDeliveries: CustomerServiceOrderDrawerOrderInfoProps["productServiceDeliveries"];
  deliveryDate: CustomerServiceOrderDrawerOrderInfoProps["deliveryDate"];
};

export function CustomerServiceOrderWorkDelivery({
  productServiceDeliveries,
  status,
  deliveryDate,
}: CustomerServiceOrderWorkDeliveryProps) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <CustomerServiceOrderWorkDeliveryHeader />
      <CustomerServiceOrderWorkDeliveryDeliveredWork
        status={status}
        productServiceDeliveries={productServiceDeliveries}
        deliveryDate={deliveryDate}
      />
    </Space>
  );
}
